import api from '../../../core/api/client';

const BASE = '/asset-requests';
const byId = (id) => `${BASE}/${encodeURIComponent(id)}`;

const toApiError = (error) => {
  if (error?.response) {
    const d = error.response.data;
    return {
      status: error.response.status,
      message: d?.detail || d?.message || d?.error || error.message || 'Request failed',
      data: d,
    };
  }
  return { status: 0, message: error?.message || 'Unexpected error', data: null };
};

const wrap = async (fn) => {
  try { return await fn(); }
  catch (error) { throw toApiError(error); }
};

export const assetRequestsService = {
  async list({ status, assigneeId, requesterId, projectId } = {}) {
    return wrap(async () => {
      const params = {};
      if (status)      params.status      = status;      // array[string] supported
      if (assigneeId)  params.assigneeId  = assigneeId;
      if (requesterId) params.requesterId = requesterId;
      if (projectId)   params.projectId   = projectId;
      const response = await api.get(BASE, { params });
      return response.data;
    });
  },

  async create(data) {
    return wrap(async () => {
      const response = await api.post(BASE, data);
      return response.data;
    });
  },

  async getMe() {
    return wrap(async () => {
      const response = await api.get(`${BASE}/me`);
      return response.data;
    });
  },

  async get(requestId) {
    return wrap(async () => {
      const response = await api.get(byId(requestId));
      return response.data;
    });
  },

  async update(requestId, patch) {
    return wrap(async () => {
      const response = await api.patch(byId(requestId), patch);
      return response.data;
    });
  },

  async delete(requestId) {
    return wrap(async () => {
      const response = await api.delete(byId(requestId));
      return response.data;
    });
  },

  async changeStatus(requestId, status) {
    return wrap(async () => {
      const response = await api.patch(`${byId(requestId)}/status`, { status });
      return response.data;
    });
  },

  async assign(requestId, assigneeId) {
    return wrap(async () => {
      const response = await api.post(`${byId(requestId)}/assign`, { assignee_id: assigneeId });
      return response.data;
    });
  },

  async review(requestId, { action, comment }) {
    return wrap(async () => {
      const response = await api.post(`${byId(requestId)}/review`, { action, comment });
      return response.data;
    });
  },

  async attachDeliverables(requestId, assetIds) {
    return wrap(async () => {
      const response = await api.post(`${byId(requestId)}/deliverables`, { asset_ids: assetIds });
      return response.data;
    });
  },
};

export const ASSET_REQUEST_STATUSES = [
  'new', 'in_progress', 'in_review', 'revisions', 'approved', 'completed', 'cancelled',
];

export const PRIORITIES = ['low', 'medium', 'high', 'urgent'];
